import { initializeFormalist } from "roneo/lib/formalist";
import assetSelection from "./components/asset-selection";
import assetOption from "./components/asset-option";
import assetOptionControl from "./components/asset-option-control";
import trackSelection from "./components/track-selection";
import trackOptionControl from "./components/track-option-control";

const selectionFields = {
  components: [
    { name: "asset", component: assetSelection },
    { name: "asset_option", component: assetOption },
    { name: "asset_option_control", component: assetOptionControl },
    { name: "track", component: trackSelection },
    { name: "track_option_control", component: trackOptionControl }
  ]
};

/**
 * Custom configuration to pass to formalist
 */
const formConfig = {
  fields: {
    selectionField: selectionFields,
    multiSelectionField: selectionFields,
    searchSelectionField: selectionFields,
    searchMultiSelectionField: selectionFields
  }
};

export function renderCustomFormalist(el, props) {
  const customProps = {
    config: { ...props.config, ...formConfig }
  };
  const form = initializeFormalist(el, { ...props, ...customProps });
  form.render();
}

/**
 * Custom wrapper for Roneo’s `data-view-formalist` component
 * @param {Node} el
 * @param {Object} props DOM-originated props
 */
export default function customFormalist(el, props) {
  renderCustomFormalist(el, props);
}
